import React from 'react';
import APModal from 'components/Modal/APModal';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import './styles.scss';

const DeleteConfirmation = ({
  show = false,
  className,
  header = true,
  title,
  cancelText = 'cancel',
  deleteText = 'delete',
  handleConfirm,
  handleClose,
  name = 'delete-confirmation',
  size,
  children,
}) => {
  return (
    <APModal
      className={clsx(className)}
      open={show}
      name={name}
      hasHeader={header}
      size={size}
      title={title}
      onClose={handleClose}
      actions={(
        <>
          <button
            type="button"
            className="button button-cancel"
            onClick={handleClose}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className="button button-delete"
            onClick={handleConfirm}
          >
            {deleteText}
          </button>
        </>
      )}
    >
      {children}
    </APModal>
  );
};

DeleteConfirmation.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  cancelText: PropTypes.string,
  deleteText: PropTypes.string,
  handleClose: PropTypes.func,
  handleConfirm: PropTypes.func,
};

DeleteConfirmation.defaultTypes = {
  show: false,
};

export default DeleteConfirmation;
